/**
 * True when Airwallex beneficiaryForm submit() reports an SDK error — block navigation.
 * Covers top-level `errors` and nested `populateAndValidateBeneficiary` (success false or error[]).
 * Does not set our custom banner; the SDK shows inline messages.
 *
 * @param {object|null|undefined} submitResult - Return value of beneficiaryForm.submit()
 * @returns {boolean}
 */
export function hasSdkSubmissionError(submitResult) {
  if (submitResult == null || typeof submitResult !== "object") {
    return false;
  }
  if (submitResult.errors != null) {
    if (submitResult.errors.code != null) {
      return true;
    }
    const nested = submitResult.errors.details?.errors;
    if (Array.isArray(nested) && nested.length > 0) {
      return true;
    }
  }
  const pav = submitResult.populateAndValidateBeneficiary;
  if (pav && typeof pav === "object") {
    if (pav.success === false) {
      return true;
    }
    if (Array.isArray(pav.error) && pav.error.length > 0) {
      return true;
    }
  }
  return false;
}

/**
 * Validates that beneficiary form values have required fields filled.
 * Prevents submitting before conditional fields are rendered or filled.
 *
 * @param {{ beneficiary?: object }} values - submitResult.values from Airwallex beneficiaryForm
 * @returns {boolean}
 */
export function isBeneficiaryFormDataComplete(values) {
  const b = values?.beneficiary;
  const bd = b?.bank_details;
  const addr = b?.address;
  if (!b || !bd) return false;
  // Required for all: entity_type, account_currency, bank_country_code
  if (!bd.account_currency || !bd.bank_country_code) return false;
  // Account identification: account number OR IBAN (EU/local flows often only return iban)
  const hasAccountId = [bd.account_number, bd.iban].some(
    (v) => v != null && String(v).trim() !== ""
  );
  if (!bd.account_name || !hasAccountId) return false;
  // At least one routing (routing type+value or swift)
  // const hasRouting = (bd.account_routing_type1 && bd.account_routing_value1) || bd.swift_code;
  // if (!hasRouting) return false;
  // Address required for most flows
  if (!addr || !addr.street_address || !addr.city || !addr.country_code) return false;
  return true;
}
